export default __webpack_public_path__ + "static/banner-f5d8993ed09609bb77dc41e8a23d8413.png";